'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPinOutline = function TiPinOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.7 12.6l-6.6-6.7c-1.3-1.2-3.5-1.2-4.8 0-0.3 0.4-0.5 0.8-0.7 1.1-1 2.3-2.2 3.7-3.7 4.5l-0.4 0.2c-1.6 0.8-3.8 1.6-7.8 1.6-0.5 0-0.9 0.1-1.3 0.3-0.8 0.3-1.5 1-1.8 1.8-0.3 0.8-0.3 1.7 0 2.5 0.2 0.5 0.4 0.8 0.7 1.1l5.4 5.4-6.4 8.9 9-6.3 5.3 5.3c0.3 0.4 0.7 0.6 1.1 0.8 0.4 0.2 0.9 0.2 1.3 0.2s0.9-0.1 1.3-0.2c0.8-0.4 1.5-1 1.8-1.8 0.2-0.4 0.2-0.9 0.2-1.3 0-4.1 0.9-6.3 1.7-7.9 0.8-1.6 2.2-2.9 4.6-4 0.4-0.2 0.8-0.4 1.1-0.8 1.3-1.3 1.3-3.4 0-4.7z m-8.7 8c-1.4 2.8-2 5.7-2 9.4l-13.3-13.3c3.5 0 6.3-0.6 9-1.8l0.3-0.2c2.4-1.2 4.2-3.2 5.7-6.4l6.5 6.7c-3.1 1.5-5.1 3.3-6.2 5.6z' })
        )
    );
};

exports.default = TiPinOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/pin-outline.js
// module id = 2142
// module chunks = 0